import { createDelayPromise } from "..";

export let linkHandling = {
    pageCallback: undefined as ((page: string) => void) | undefined,
    settingsCallbacks: {} as Record<string, (() => void) | undefined>,

    reset: () => {
        linkHandling.pageCallback = undefined;
        linkHandling.settingsCallbacks = {};
    },

    open: async (page: string, setting?: string) => {
        linkHandling.pageCallback?.(page);
        await createDelayPromise(0);
        if (!setting) return;
        linkHandling.settingsCallbacks[setting]?.();
        await createDelayPromise(0);
    }
}
